import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'businesses',
    data () {
        return {
            admin:{},
            businesses: {},
            business: {},
            viewFlag: "",
            img_url: service.imageURL,
            deleteRequest: false
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.business = attr2;
            }
            
        },
        requests(req){
            if(req == "delete"){ this.deleteRequest = true;}
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and businesses
        
        //get all saved listings
        getBusinesses() {
            service.getAllBusinesses(this).then(data => {
               if(data.body.status == 200) {
                    this.businesses = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //delete listing
        deleteListing() {
            service.adminDeleteBusiness(this, this.business.business_id).then(data => {
               if(data.body.status == 200) {
                    toastr.error('removed', 'Warning!');
                    location.reload(true);
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
    
     
    },
    created: function(){
        this.preset();
        this.getBusinesses();
    }
}


// WEBPACK FOOTER //
// ./src/components/Businesses/script.js